<div *ngIf="selectedCar" class="redirect-brand">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-8">
        <p>
          {{ "redirectBrand.content" | translate }}
          <a href="#" (click)="redirectBrand($event)">{{ redirectUrl }}</a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="mx-auto mt-4 col-2">
        <span
          class="back-link color-white pointer"
          (click)="backToFromBrandURL()"
          >{{ "back" | translate }} <i class="fal fa-times ms-2"></i
        ></span>
      </div>
    </div>
  </div>
</div>
